import { Component } from '@angular/core';
import { Avatar } from '../avatar/avatar';

@Component({
  selector: 'app-header',
  imports: [Avatar],
  templateUrl: './header.html',
  styleUrl: './header.scss',
})
export class Header {}
